import { Box, Grid2 } from '@mui/material'
import React from 'react'
import Heading from '../../shared/utils/Heading'
import { Page_Padding } from '../../shared/constants'
import FaqCard from '../../shared/components/FaqCard'
import { useFaq } from '../../assets/api/useGetApi'
import { SkeletonCom } from '../../shared/utils/SkeletonCom'

const Faq = () => {
    const { data: faqData, isLoading } = useFaq();
    return (
        <Box className="body contact_us" px={Page_Padding}>
            <Heading
                Heading={"Curious Minds: Get the Answers You’re Looking For!"}
                SubHeading={"Got questions? We’ve got the answers!"}
            />

            <Grid2 container spacing={5} sx={{ display: 'flex', justifyContent: "center" }}>
          
            {!isLoading &&
                    faqData?.data?.elements.map((item, index) => {

                        return (
                            <Grid2 hildren size={{ xs: 12, sm: 6, md: 4 }} key={index}
                                display={"flex"} alignItems={"stretch"}
                            >
                                <FaqCard index={index} item={item} />
                            </Grid2>
                        );
                    })
                }

                {
                    isLoading && [...Array(6)].map((_, index) => (
                        <Grid2 children size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                            <SkeletonCom />
                        </Grid2>
                    ))
                }


            </Grid2>
        </Box>
    )
}

export default Faq